import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=3e275924&scoped=true&"
import script from "./OverviewView.vue?vue&type=script&lang=ts&"
export * from "./OverviewView.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=3e275924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e275924",
  null
  
)

export default component.exports